/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
// import { amplifyLocalStorage } from "@nitric/amplify-secure-js";

const config = {
  aws_project_region: "ap-northeast-1",
  aws_content_delivery_bucket: "kagura-prd-frontend-hostingbucket-prd",
  aws_content_delivery_bucket_region: "ap-northeast-1",
  aws_content_delivery_url: "https://djz68bo3bbza6.cloudfront.net",
  aws_cognito_identity_pool_id:
    "ap-northeast-1:d632f748-a259-40ce-8973-ef3b53b1c8ec",
  aws_cognito_region: "ap-northeast-1",
  aws_user_pools_id: "ap-northeast-1_iN1bSbUrL",
  aws_user_pools_web_client_id: "652d2l7gc7rusqo1s94slkn3hb",
  oauth: {},
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_mfa_configuration: "OFF",
  aws_cognito_mfa_types: ["SMS"],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ["EMAIL"],
  authenticationFlowType: "CUSTOM_AUTH",
  Auth: {
    cookieStorage: {
      domain: ".dbarai-merchant.docomo.ne.jp",
      path: "/",
      expires: 365,
      sameSite: "strict",
      secure: true,
    },
  },
};

export default config;
